import { compatibility } from '@seek/ca-myprofile-utils';
import { useMelwaysInfo } from '@seek/melways-react';
import { Stack } from 'braid-design-system';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { useAnalytics } from 'src/contexts/AnalyticsContext';
import { useTypedSelector } from 'src/reducers';
import getBrandSpecificDescription from 'src/utils/getBrandSpecificDescription';
import getBrandSpecificTitle from 'src/utils/getBrandSpecificTitle';

import { useUserProfile } from '../Notifications/hooks/useUserProfile';

import { ChangeEmail } from './ChangeEmail/ChangeEmail';
import DeleteAccount from './DeleteAccount/DeleteAccount';

export const Account = () => {
  const site = useTypedSelector((state) => state.page.pageAnalytics.site);
  const { language: melwaysLanguage } = useMelwaysInfo();
  const language =
    compatibility.getCompatibleLanguageFromLocaleString(melwaysLanguage);

  const { user } = useUserProfile();
  const { trackPageLoad } = useAnalytics();

  useEffect(() => {
    if (user) {
      trackPageLoad({ currentPage: 'account settings' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]); // Disabling dependency on trackPageLoad to only track initial tab render

  return (
    <>
      <Helmet>
        <title>{getBrandSpecificTitle(site, language)}</title>
        <meta
          name="description"
          content={getBrandSpecificDescription(site, language)}
        />
      </Helmet>
      <Stack space="small">
        <ChangeEmail />
        <DeleteAccount />
      </Stack>
    </>
  );
};
